module.exports = __webpack_public_path__ + "df3212e0f7d0081c20e1de8dcae4cc3c.png";